import {
  CustomTextField,
  DrawerFormSection,
} from '../../../../common/components';
import {
  AttachmentPicker,
  invoiceFieldSpan,
} from '../SupplierLedgerShared';

const SupplierInvoiceControlSection = ({
  currentAttachmentName,
  file,
  form,
  onChange,
  onFileChange,
}) => (
  <DrawerFormSection title="Control y adjunto">
    <CustomTextField
      label="Motivo duplicado"
      name="duplicate_override_reason"
      value={form.duplicate_override_reason}
      onChange={onChange}
      sx={invoiceFieldSpan(5, 2)}
    />
    <AttachmentPicker
      file={file}
      onFileChange={onFileChange}
      currentFileName={currentAttachmentName}
      sx={invoiceFieldSpan(7, 2)}
    />
  </DrawerFormSection>
);

export default SupplierInvoiceControlSection;
